module.exports = __webpack_public_path__ + "static/media/Group 4369.b7fb85c5.svg";